$(function() {
	jQuery(function ($) {
		$('.form-phone').inputmask({mask: '+7 (999) 999 - 99 - 99', clearIncomplete: true})
	});
})